module.exports = __webpack_public_path__ + "static/media/pfp.b2cc3134.png";